import React from 'react'

export const TableStatusChip = ({ status, tone }) => {
  const normalized = String(status || '').toLowerCase()
  const resolved =
    tone ||
    (['active', 'completed', 'ok', 'success', 'sent', 'ready'].includes(normalized)
      ? 'ok'
      : ['open', 'pending', 'idle', 'inactive'].includes(normalized)
        ? 'idle'
        : ['in-progress', 'processing', 'running', 'maintenance', 'warn'].includes(
              normalized
            )
          ? 'warn'
          : ['error', 'failed', 'danger', 'bad'].includes(normalized)
            ? 'bad'
            : 'info')

  const className =
    resolved === 'ok'
      ? 'nx-chip-ok'
      : resolved === 'warn'
        ? 'nx-chip-warn'
        : resolved === 'bad'
          ? 'nx-chip-bad'
          : resolved === 'idle'
            ? 'nx-chip-idle'
            : 'nx-chip-info'

  return <span className={className}>{status}</span>
}

export const TableSkeletonRows = ({ columns = 5, rows = 6 }) => (
  <>
    {Array.from({ length: rows }).map((_, rowIndex) => (
      <tr key={`skeleton-${rowIndex}`}>
        {Array.from({ length: columns }).map((__, colIndex) => (
          <td key={`skeleton-${rowIndex}-${colIndex}`}>
            <div className="h-4 w-full max-w-[9rem] animate-pulse rounded bg-rule/70" />
          </td>
        ))}
      </tr>
    ))}
  </>
)

export const TableEmptyRow = ({
  columns = 5,
  title = 'No rows found',
  description = 'Try a different search or create a new item.',
}) => (
  <tr>
    <td colSpan={columns} className="!py-12 text-center">
      <p className="font-display text-xl tracking-wide text-paper">{title}</p>
      {description && <p className="mt-1 text-sm text-muted">{description}</p>}
    </td>
  </tr>
)

export const TableIdCell = ({ children, className = '' }) => (
  <span className={`font-mono text-xs text-signal ${className}`}>{children}</span>
)

export const TableActionGroup = ({ children }) => (
  <div className="flex items-center gap-1">{children}</div>
)
